import { ComplianceItem } from "@/components/ui/TrainingListControl";

export const isBlockingComplianceItem = (item?: ComplianceItem | null) => {
  if (!item?.required) {
    return false;
  }

  const normalizedStatus = `${item.status || ''}`.trim().toUpperCase();
  if (
    normalizedStatus === "PAST_DUE" ||
    normalizedStatus === "REQUIRED"
  ) {
    return true;
  }

  if (normalizedStatus === "DUE_SOON") {
    return typeof item.dueInDays === "number" ? item.dueInDays <= 0 : false;
  }

  if (normalizedStatus === "CURRENT" || normalizedStatus === "OPTIONAL") {
    return false;
  }

  if (typeof item.dueInDays === "number") {
    return item.dueInDays <= 0;
  }

  return false;
};

export const getBlockingComplianceItems = (items?: ComplianceItem[] | null) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.filter((item): item is ComplianceItem => isBlockingComplianceItem(item));
};

export const hasBlockingComplianceItems = (items?: ComplianceItem[] | null) => {
  return getBlockingComplianceItems(items).length > 0;
};

const getPathname = (value?: string | null) => {
  if (!value) {
    return "";
  }

  const [pathWithoutHash] = value.split("#");
  const [pathname] = pathWithoutHash.split("?");
  return pathname || "";
};

export const isAllowedComplianceRoute = (pathname: string, items?: ComplianceItem[] | null) => {
  return getBlockingComplianceItems(items).some((item) => getPathname(item.actionPath) === pathname);
};

export const getComplianceReturnPath = (pathname: string, search = "") => {
  if (!pathname || pathname === "/login" || pathname === "/loginAD") {
    return "/dashboard";
  }

  return `${pathname}${search || ""}`;
};

export const withComplianceReturnPath = (actionPath: string, returnPath: string) => {
  if (!actionPath || !returnPath || actionPath.includes("return=")) {
    return actionPath;
  }

  const separator = actionPath.includes("?") ? "&" : "?";
  return `${actionPath}${separator}return=${encodeURIComponent(returnPath)}`;
};
